/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Desc_RecordedInputs */

const en_wb_desc_recorded = /** @type {(inputs: Wb_Desc_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your review is recorded in this example.`)
};

const lv_wb_desc_recorded = /** @type {(inputs: Wb_Desc_RecordedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu pārbaude šajā piemērā ir reģistrēta.`)
};

/**
* | output |
* | --- |
* | "Your review is recorded in this example." |
*
* @param {Wb_Desc_RecordedInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_desc_recorded = /** @type {((inputs?: Wb_Desc_RecordedInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Desc_RecordedInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_desc_recorded(inputs)
	return en_wb_desc_recorded(inputs)
});